// extracted by mini-css-extract-plugin
module.exports = {"editText":"CustomAuth_editText__2Mj49","loginButton":"CustomAuth_loginButton__3AEGR","forgotPasswordButton":"CustomAuth_forgotPasswordButton__3V4I-"};